import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function BirthCertificateSettingsContent({
  handleEdit,
  settingsId,
  showBirthCertificateSettings,
  birthCertificateSettings,
}) {
  useEffect(() => {
    if (_.isEmpty(settingsId)) return;
    showBirthCertificateSettings(settingsId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(settingsId)) return;
    showBirthCertificateSettings(settingsId);
  }, [settingsId]);

  const renderStatus = (status) => {
    if (status) {
      return <div className="btn btn-sm btn-success">ACTIVE</div>;
    }
    return <div className="btn btn-sm btn-danger">INACTIVE</div>;
  };

  return (
    <div className="container-fluid card-section-content">
      {!_.isEmpty(birthCertificateSettings) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Settings Information</h3>
                <div>
                  <button
                    type="button"
                    className="btn btn-warning mr-2"
                    onClick={handleEdit(birthCertificateSettings)}
                  >
                    Edit Settings
                  </button>
                </div>
              </div>
              <hr />
              <div className="mt-4">
                <div className="row d-flex justify-content-center">
                  <div className="col">
                    <table className="table table-striped table-borderless">
                      <tbody>
                        <tr>
                          <th className="table-title">Name:</th>
                          <td>
                            {_.get(
                              birthCertificateSettings,
                              'attributes.name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Amount:</th>
                          <td>
                            {_.get(
                              birthCertificateSettings,
                              'attributes.amount'
                            ) || '--'}
                          </td>
                        </tr>
                        {/* <tr>
                          <th className="table-title">Rush Amount:</th>
                          <td>
                            {_.get(
                              birthCertificateSettings,
                              'attributes.rush_amount'
                            ) || '--'}
                          </td>
                        </tr> */}
                        <tr>
                          <th className="table-title">Computer Fee:</th>
                          <td>
                            {_.get(
                              birthCertificateSettings,
                              'attributes.computer_fee'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Status:</th>
                          <td>
                            {renderStatus(
                              _.get(
                                birthCertificateSettings,
                                'attributes.is_active'
                              )
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

BirthCertificateSettingsContent.propTypes = {
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  showBirthCertificateSettings: PropTypes.instanceOf(Function).isRequired,
  birthCertificateSettings: PropTypes.instanceOf(Object).isRequired,
  settingsId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  birthCertificateSettings:
    _.get(api, `${c.SHOW_BIRTH_CERTIFICATE_SETTINGS}.item`) || {},
  settingsId: _.get(match, 'params.settingsId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BirthCertificateSettingsContent);
